import React, {useState} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardMedia from '@material-ui/core/CardMedia';
import CardActionArea from '@material-ui/core/CardActionArea';
import {Divider} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import HttpService from "../../../../services/http.service";
import {getUserDataFromLocalStorage} from "../../../../services/utils";
import {RecordInterestModal, Alert} from '../../../'
import {banner} from '../../../../assets/images/images'

const useStyles = makeStyles({
  root: {
    // maxWidth: 200,
    marginLeft: 20,
    marginRight: 20,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    paddingTop: 5,
    paddingBottom: 5,

    // paddingLeft: 20,
    // paddingRight: 20,
    borderRadius: 4,
    // width:200
    // backgroundColor:'red'
  },
});

const Heading = ({title}) => (
  <th className=' text-capitalize' style={{paddingTop: 15, paddingBottom: 15}}>{title}</th>);
const CustomDivider = () => <tr>
  <td colSpan={4}>
    <Divider style={{width: '100%', background: 'lightgray'}}/>
  </td>
</tr>

export default function ImgMediaCard(props) {
  const classes = useStyles();
  const [error, setError] = useState("")
  const [success, setSuccess] = useState("");

  let user = getUserDataFromLocalStorage()
  const {index, key, val, item} = props;

  return (
    <Card className={classes.root}>
      {((error || success)) &&
        <Alert type={error ? 'error' : 'success'}
               message={error || success}/>
      }
      <CardMedia
        component="img"
        height="180"
        image={banner}
        alt={item.searchSubCategory || 'Buyer request'}
        style={{width: "80%"}}
      />

      <CardActionArea className='mt-10' style={{paddingLeft: 25, paddingRight: 25,}}>
        <table style={{borderCollapse: 'collapse', width: '100%'}}>
          <tr style={{marginTop: 10}}>
            <Heading title={'type'}/>
            <td className='text-capitalize'>{item.searchType}</td>
            <Heading title={'category'}/>
            <td className='text-capitalize'>{item.searchSubCategory}</td>
          </tr>
          <CustomDivider/>
          <tr>
            <Heading title={'Target price:'}/>
            <td>{item.currency}{item.priceTo}/{item.qtyname || 'kilos'}</td>
            <Heading title={'Min Qty Price:'}/>
            <td>{item.currency}{item.priceFrom}/{item.qtyname || 'kilos'}</td>
          </tr>
          <CustomDivider/>
          <tr>
            <Heading title={'Quantity:'}/>
            <td>{item.qty}/{item.qtyname}</td>
            <Heading title={'Closing Date:'}/>
            <td>{item.investmentClosingDate}</td>
          </tr>
          <CustomDivider/>
          <tr>
            <Heading title={'Target Location:'}/>
            <td>{item.city}</td>
            {/*<td></td>*/}
            <td colSpan={2} className='ml-15'>
              <Button type="submit" variant="contained" color="primary"
                      onClick={(e) => {
                        props.setModal(!props.modal)
                        console.log('add interest')
                      //   HttpService.post(`api/recordinterest/save?contactno=${user.mobileNumber}&email=${user.email}&savedSearchId=${item.searchID}&preferredMethod=SMS&ssoId=${user.ssoId}&shareCurrency=${item.currency || '$'}&shareQty=${item.qty}`).then(res => {
                      //     if (res && res?.data?.message === "SUCCESS") {
                      //       setSuccess(res?.data?.messageText)
                      //       setTimeout(() => {
                      //         setSuccess("")
                      //       }, 5000);
                      //     } else
                      //       setError(res?.data?.messageText)
                      //     setTimeout(() => {
                      //       setError("")
                      //     }, 5000);
                      //   });
                      }

                      }
              >
                Record Interest
              </Button>
            </td>
          </tr>
          {/*<CustomDivider/>*/}

        </table>
        {/*<div className='display-flex justify-content-center align-items-center'>*/}
        {/*  /!*{data.map((i, ind) => <img src={starFill} key={ind} alt='star'/>)}*!/*/}
        {/*  Product / Service*/}
        {/*</div>*/}
        {/*<p>Category</p>*/}
        {/*<p> Islamabad, Pakistan</p>*/}
        {/*<Typography variant="body2" color="textSecondary" component="p" className='text-center pt-10 max-width-80 '>*/}
        {/*  Arrived as expected, well packed properly protected, looks good construction and finish. Arrived quickly and without any extra fee.*/}
        {/*</Typography>*/}

      </CardActionArea>
    </Card>
  );
}
